import { centerable as e } from "../decorators/centerable.js";
import { uploadable as a } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as t } from "../../constants.js";
import { defineAttrs as c } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const l = c({
  type: { default: "audioFile" },
  url: { default: "" }
}), m = e(
  a({
    inline: !1,
    draggable: !0,
    attrs: l,
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-audio-file",
        getAttrs(r) {
          return {
            url: r.querySelector("audio")?.getAttribute("src") ?? ""
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-audio audio",
        getAttrs(r) {
          return {
            url: r.querySelector("source")?.getAttribute("src") ?? ""
          };
        }
      }
    ],
    toDOM(r) {
      const o = r.attrs;
      return [
        "div",
        {
          class: `${t.blockContainer} ${t.audio}`
        },
        [
          "audio",
          {
            class: "block-audio-file-player",
            controls: "",
            controlsList: "nodownload nofullscreen noremoteplayback noplaybackrate",
            src: o.url,
            style: "width: 100%;"
          }
        ]
      ];
    }
  })
);
export {
  m as audioFileSpec
};
